import React from 'react';
import IconButton from 'material-ui/IconButton';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import IconMenu from 'material-ui/IconMenu';
import MenuItem from 'material-ui/MenuItem';
import style from '../../../styles/styles';
import PropTypes from 'prop-types';
import {grey400} from 'material-ui/styles/colors';
import {Link} from "react-router-dom";
import Avatar from 'material-ui/Avatar';
import {ListItem} from 'material-ui/List';
import AdminService, {ADMIN} from "../../../services/admin";
import withTranslation from "../../../hoc/withTranslation";
import {
    EDIT_REPORTSUBJECT_PAGE,
    REPORTSUBJECT_PAGE,
} from "../../../constants/routes";

class ReportSubject extends React.Component {

    static propTypes = {
        reportSubject: PropTypes.object.isRequired,
        app: PropTypes.object,
        user: PropTypes.object,
        handleRemoveReportSubject: PropTypes.func
    };

    handleRemoveReportSubject = () => {
        this.props.handleRemoveReportSubject(this.props.reportSubject);
    };

    rightIconButton = () => {
        if (!this.props.user || !this.props.app) {
            return
        }

        const iconButtonElement = (
            <IconButton
                touch={true}
                tooltipPosition="bottom-left"
            >
                <MoreVertIcon color={grey400}/>
            </IconButton>
        );

        return (
            <IconMenu
                iconButtonElement={iconButtonElement}
                listStyle={style.list}
                anchorOrigin={{horizontal: 'right', vertical: 'top'}}
                targetOrigin={{horizontal: 'right', vertical: 'top'}}
            >
                <Link to={REPORTSUBJECT_PAGE.replace(':appId', this.props.app.id).replace(':reportsubjectId', this.props.reportSubject.id)}>
                    <MenuItem>
                        {this.props.t('generic.detail')}
                    </MenuItem>
                </Link>
                {AdminService.isAuthorized(ADMIN, this.props.user) &&
                    <Link to={EDIT_REPORTSUBJECT_PAGE.replace(':appId', this.props.app.id).replace(':reportsubjectId', this.props.reportSubject.id)}>
                        <MenuItem>
                            {this.props.t('generic.edit')}
                        </MenuItem>
                    </Link>
                }
                {AdminService.isAuthorized(ADMIN, this.props.user) && this.props.handleRemoveReportSubject &&
                    <MenuItem onClick={this.handleRemoveReportSubject}>
                        {this.props.t('generic.remove')}
                    </MenuItem>
                }
            </IconMenu>
        )
    };

    render() {
        const {reportSubject} = this.props;

        return (
            <ListItem
                leftAvatar={
                    <Avatar
                        icon={reportSubject.picture && <img src={reportSubject.picture} alt="" style={style.image.contain}/>}
                        size={40}
                        backgroundColor={reportSubject.color}
                        style={{ overflow: 'hidden' }}
                    />
                }
                primaryText={reportSubject.name}
                secondaryText={reportSubject.id}
                rightIconButton={this.rightIconButton()}
            />
        );
    }
}

export default withTranslation(ReportSubject);



// WEBPACK FOOTER //
// src/components/report/ReportSubject/ReportSubject.js